module.exports = __webpack_public_path__ + "img/05A.fec436a3.jpg";